// Service categories ("tags") for projects, invoice lines and invoices.

export const DEFAULT_TAGS = [
  { id: "seo", name: "SEO", color: "#16a34a" },
  { id: "local-seo", name: "Local SEO / GMB", color: "#0d9488" },
  { id: "google-ads", name: "Google Ads", color: "#2563eb" },
  { id: "meta-ads", name: "Meta Ads", color: "#7c3aed" },
  { id: "social", name: "Social Media", color: "#db2777" },
  { id: "website", name: "Website", color: "#ea580c" },
  { id: "maintenance", name: "Maintenance", color: "#ca8a04" },
  { id: "email", name: "Email / WhatsApp", color: "#0891b2" },
  { id: "chatbot", name: "Chatbot / AI", color: "#4f46e5" },
  { id: "other", name: "Other", color: "#64748b" },
];

// Keyword rules, first match wins. Order matters (e.g. "website maintenance" → Maintenance).
const RULES = [
  ["maintenance", /maint[ae]n[ae]nce|hosting|support|amc/i],
  ["meta-ads", /\bmeta\b|facebook ads|instagram ads|\bfb ads/i],
  ["google-ads", /google ads|\bppc\b|\bads\b|adwords|\bsem\b/i],
  ["local-seo", /\bgmb\b|google business|\bgeo\b|local seo|citation/i],
  ["chatbot", /chat ?bot|\bai\b|automation/i],
  ["email", /e-?mail|whatsapp|newsletter|sms/i],
  ["social", /social|linkedin|instagram|facebook|blue tick|reels|posts?\b/i],
  ["seo", /\bseo\b|keywords?|keyoword|backlink|on-?page/i],
  ["website", /website|web ?site|landing page|development|design|wordpress|shopify|\bweb\b|\bapp\b/i],
];

export function suggestTag(text, tags = DEFAULT_TAGS) {
  const ids = new Set(tags.map((t) => t.id));
  for (const [id, re] of RULES) if (ids.has(id) && re.test(text || "")) return id;
  // fall back to a user-made tag whose name appears in the text
  const t = tags.find((x) => x.name && new RegExp(`\\b${x.name.replace(/[.*+?^${}()|[\]\\/]/g, "\\$&")}\\b`, "i").test(text || ""));
  return t?.id || "";
}

// Effective tags of an invoice: manual tags + every line's tag.
export function invoiceTags(inv) {
  return [...new Set([...(inv.tags || []), ...(inv.items || []).map((l) => l.tag).filter(Boolean)])];
}

export const tagById = (tags, id) => tags.find((t) => t.id === id);
